import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  consumerNumber: "",
  applicationTypeId: 9,
  connectionLoad: {
    id: 0,
    backupRequired: "",
    backupkVA: "",
    powerRequirementUnit: "",
    loadDetails: "",
    supplyVoltage: "",
    supplyVoltageUnit: "",
    powerRequirement: "",
    timeShift: "",
    tention: "",
  },
  extraValues: {
    premiseTypeId: "",
    premiseUsagePurpose: "",
  },
};

const changeOfCategorySlice = createSlice({
  name: "changeOfCategory",
  initialState,
  reducers: {
    setValues(_, action) {
      return action.payload;
    },
  },
});

export const { setValues } = changeOfCategorySlice.actions;

export default changeOfCategorySlice.reducer;
